import { render, staticRenderFns } from "./downloadBrochure.vue?vue&type=template&id=47a3141b&"
import script from "./downloadBrochure.vue?vue&type=script&lang=js&"
export * from "./downloadBrochure.vue?vue&type=script&lang=js&"
import style0 from "./downloadBrochure.vue?vue&type=style&index=0&id=47a3141b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports